export type HealthStatus =
    | 'Unknown'
    | 'Healthy'
    | 'Degraded'
    | 'Unhealthy'
    | 'Disabled'
    | 'Ignored';

// Pipeline enum matching C# Azure.AirGap.Common.Models.Enums.Pipeline
export enum Pipeline {
    Blob = 0,      // Data pipeline (CTS Engine)
    Core = 1,      // Dialtone pipeline (CTS Core)
    Message = 2,   // Message pipeline (CTS Core for messages)
}

// WorkLane enum matching C# Azure.AirGap.Common.Models.Enums.WorkLane
export enum WorkLane {
    Warm = 0,      // Normal priority (WARM)
    Dcmt = 1,      // High priority (DCMT)
}

// Region enum matching C# Azure.AirGap.Common.Models.Enums.Region  
export enum Region {
    Primary = 0,   // Primary region
    Secondary = 1, // Secondary region
}

export type CloudOwnership = 'Public' | 'Cloud';
export type StageOwner = 'SRM' | 'CTS';

export interface PipelineStageData {
    name: string;
    status: HealthStatus;
    owner: StageOwner;
    cloudOwnership: CloudOwnership;
}

export interface PipelineConnectionData {
    status: HealthStatus;
}

export interface RegionalPipelineData {
    flowId: string;
    pipeline: Pipeline;
    workLane: WorkLane;
    region: Region;
    ctsType: string;
    direction: string;
    sourceRegion: string;
    destinationRegion: string;
    source: string;
    destination: string;
    primaryRegion: string;
    secondaryRegion: string;
    isActive: boolean;
    stages: {
        public: PipelineStageData;
        publicTransfer: PipelineStageData;
        cloudArrive: PipelineStageData;
        cloudEngine: PipelineStageData;
        cloudPlatform: PipelineStageData;
    };
    connections: {
        publicToPublicTransfer: PipelineConnectionData;
        publicTransferToCloudArrive: PipelineConnectionData;
        cloudArriveToCloudEngine: PipelineConnectionData;
    };
    metadata?: {
        CtsType?: string;
        Direction?: string;
        SourceRegion?: string;
        Source?: string;
        Intermediate?: string;
        Destination?: string;
        DestinationRegion?: string;
        IsActive?: string;
    };
}

export interface ComponentData {
    componentId: string;
    componentName: string;
    health: HealthStatus;
    lastUpdated: Date;
}

export interface EventData {
    eventId: string;
    environmentName: string;
    eventType: string;
    serviceSourceGuid: string;
    componentGuid: string;
    componentIndex: number;
    statusGuid: string;
    statusIndicatorEnum: number;
    trueValue: number;
    additionalValue: number;
    errorCode: number;
    health: HealthStatus;
    eventDate: Date;
}

export interface ServiceData {
    serviceId: string;
    serviceName: string;
    health: HealthStatus;
    lastUpdated: Date;
    stage:
        | 'Public'
        | 'Public Transfer'
        | 'Cloud Arrive'
        | 'Cloud Engine'
        | 'Cloud Platform';
    components: ComponentData[];
    events: EventData[];
}

export interface EnvironmentFeatures {
    CachingEnabled: boolean;
    MessagingEnabled: boolean;
    StorageUploadEnabled: boolean;
    OctopusEnabled: boolean;
    LockBoxEnabled: boolean;
    EgressEnabled: boolean;
    IcmEnabled: boolean;
    UseDynamicHealthChecks: boolean;
    UseSrxV2: boolean;
}

export interface CloudData {
    cloudName: string;
    overallHealth: HealthStatus;
    pipelines: RegionalPipelineData[];
    services: ServiceData[];
    operationMode?: string;
    region?: string;
    pipeline?: string;
    features?: EnvironmentFeatures;
}

export type StageType =
    | 'Public'
    | 'Public Transfer'
    | 'Cloud Arrive'
    | 'Cloud Engine'
    | 'Cloud Platform'
    | 'Overall';
